import {lazy} from "react"
export const Inicio= lazy(()=> import(/* webpackChunkName: "home" */"./Inicio"))
export const LabResults= lazy(()=> import(/* webpackChunkName: "LabResults" */"./LabResults"))
